import { makeStyles } from '@mui/styles';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import {
  LearningContentListItem,
  learningContentDefaultTranslations,
  MetadataDuration,
} from '../../../learning-content';

import PathCertification from '../PathCertification';
import Illustration, { getIllustrationStyles } from '../Illustration';

const useStyles = makeStyles(({ palette, shadows, spacing, breakpoints, radius }) => {
  const { illustration } = getIllustrationStyles();
  return {
    root: {
      border: `1px solid ${palette.layout.line.divider}`,
      boxSizing: 'border-box',
      borderRadius: radius.productCard,
    },
    informationContainer: {
      padding: spacing(2, 2, 1),
      margin: 0,
      zIndex: 2,
    },
    illustrationContainer: {
      height: 106,
      maxWidth: 'none',
      width: '100%',
      [breakpoints.up('sm')]: {
        height: 160,
      },
    },
    listItemInner: {
      padding: 0,
      width: '100%',
      height: '100%',
      flexDirection: 'column',
      '&:hover': {
        boxShadow: shadows[6],
        background: 'transparent',
      },
    },
    sublineLabel: {
      marginBottom: 0,
      display: 'flex',
      flexDirection: 'column',
      rowGap: spacing(1),
    },
    title: {
      marginBottom: spacing(2),
      height: 'auto',
    },
    content: {
      marginTop: spacing(1),
    },
    illustrationWrapper: {
      height: '100%',
      backgroundColor: illustration.backgroundColor,
      '& img': {
        position: 'absolute',
        height: '100%',
        width: 'auto',
        left: '50%',
        top: 0,
        transform: 'translate(-50%, 0)',
      },
    },
  };
});

export default function PathCard({
  certification = null,
  duration = '',
  title,
  children = null,
  illustration = '',
  locale = 'en',

  translations = {
    jobGuarantee: 'Job guarantee',
    certification: 'Diploma',
    partners: 'Partners',
    durationFullTimeMonths: learningContentDefaultTranslations.durationFullTimeMonths,
    ...learningContentDefaultTranslations,
  },
  ...otherProps
}) {
  const classes = useStyles();
  const metadata = [];
  const { illustrationWrapper: illustrationWrapperClass, ...otherClasses } = classes;

  if (certification) {
    metadata.push(
      <PathCertification
        key="certification"
        translations={{
          accessibilityLabel: translations.certification,
        }}
      >
        {certification}
      </PathCertification>
    );
  }

  if (duration) {
    metadata.push(
      <MetadataDuration
        key="duration"
        duration={duration}
        translations={{
          ...translations,
          durationMonths: translations.durationFullTimeMonths,
        }}
        icon={CalendarTodayIcon}
      />
    );
  }

  const illustrationRenderingProps =
    typeof illustration === 'string'
      ? { illustrationComponent: Illustration, illustration }
      : {
          illustration: <div className={illustrationWrapperClass}>{illustration}</div>,
        };

  return (
    <LearningContentListItem
      metadata={metadata}
      title={title}
      classes={otherClasses}
      locale={locale}
      translations={translations}
      {...illustrationRenderingProps}
      {...otherProps}
    >
      {children}
    </LearningContentListItem>
  );
}
